import { render, staticRenderFns } from "./NavTable.vue?vue&type=template&id=254d3530&"
import script from "./NavTable.vue?vue&type=script&lang=js&"
export * from "./NavTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports